import { render, staticRenderFns } from "./QuestionCreateModal.vue?vue&type=template&id=6ae71abc"
import script from "./QuestionCreateModal.vue?vue&type=script&lang=js"
export * from "./QuestionCreateModal.vue?vue&type=script&lang=js"
import style0 from "./QuestionCreateModal.vue?vue&type=style&index=0&id=6ae71abc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports